import React from 'react';
import { TCN } from './tokens';

/**
 * TCN StatRow — flex row with a label on the leading side and a value on the trailing side.
 * Optional small caret/icon trailing for tappable rows.
 *
 * Props:
 *  - label: ReactNode
 *  - value: ReactNode
 *  - hint: optional secondary text under the label
 *  - trailing: optional ReactNode (icon, chip, etc.)
 *  - mono: boolean — render value with tabular-nums/mono font
 *  - divider: boolean — top border (default false)
 */
const StatRow = ({
  label,
  value,
  hint,
  trailing,
  mono = false,
  divider = false,
  onClick,
  className = '',
  style,
}) => {
  return (
    <div
      onClick={onClick}
      className={`flex items-center justify-between ${onClick ? 'cursor-pointer' : ''} ${className}`}
      style={{
        padding: '10px 0',
        borderTop: divider ? `1px solid ${TCN.border}` : 'none',
        gap: 12,
        fontFamily: TCN.fontSans,
        ...style,
      }}
    >
      <div style={{ minWidth: 0, flex: 1 }}>
        <div
          style={{
            fontSize: 13,
            fontWeight: 600,
            color: TCN.text,
            lineHeight: 1.3,
          }}
        >
          {label}
        </div>
        {hint && (
          <div
            style={{
              fontSize: 11,
              color: TCN.textDim,
              marginTop: 2,
              lineHeight: 1.3,
            }}
          >
            {hint}
          </div>
        )}
      </div>
      <div
        style={{
          fontSize: 14,
          fontWeight: 600,
          color: TCN.text,
          fontFamily: mono ? TCN.fontMono : TCN.fontSans,
          fontVariantNumeric: mono ? 'tabular-nums' : 'normal',
          textAlign: 'end',
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          gap: 8,
        }}
      >
        <span>{value}</span>
        {trailing}
      </div>
    </div>
  );
};

export default StatRow;
